import React from 'react';
import InputMask from 'react-input-mask';
import moment from 'moment';

export const UI_DATE_FORMAT_REGEX = /\d\d\/\d\d\/\d\d\d\d/;
export const DB_DATE_FORMAT_REGEX = /\d\d\d\d\-\d\d\-\d\d/;

export const DATE_FORMAT_CHARS = {
  '1': '[0-1]',
  '2': '[0-9]',
  '3': '[0-3]',
  '4': '[1-2]',
  '5': '(0|9)',
  '9': '[0-9]'
};

export const onBlur = (e, setFieldValue) => {
  const fieldName = e.target.getAttribute('name');
  if (UI_DATE_FORMAT_REGEX.test(e.target.value)) {
    setFieldValue(fieldName, e.target.value, false);
  } else {
    setFieldValue(fieldName, '', false);
  }
};

export const onKeyPress = (e, setFieldValue) => {
  const enterKeyCode = 13;
  if (e.which === enterKeyCode) {
    onBlur(e, setFieldValue);
  }
};

// converts data from 'yyyy-mm-dd' to 'mm/dd/yyyy'
export const transformDateToUI = dateString => {
  if (!DB_DATE_FORMAT_REGEX.test(dateString)) {
    return '';
  }
  const [year, month, date] = dateString.split('-');
  return `${month}/${date}/${year}`;
};

// converts data from 'mm/dd/yyyy' to 'yyyy-mm-dd'
export const transformDateToDB = dateString => {
  if (!UI_DATE_FORMAT_REGEX.test(dateString)) {
    return '';
  }
  const [month, date, year] = dateString.split('/');
  return `${year}-${month}-${date}`;
};

export const transformDatesToUI = egr => ({
  ...egr,
  effectiveStartDate: transformDateToUI(egr.effectiveStartDate),
  effectiveEndDate: transformDateToUI(egr.effectiveEndDate)
});

export const validDate = value =>  {
  if (!value) {
    return true;
  }
  return moment(value, 'MM/DD/YYYY', true).isValid();
};

export const validateDates = egr => {
  const errors = [];
  if (!validDate(egr.effectiveStartDate)) {
    errors.push('Effective start date must be in MM/DD/YYYY format');
  }
  if (!validDate(egr.effectiveEndDate)) {
    errors.push('Effective end date must be in MM/DD/YYYY format');
  }
  if (moment(egr.effectiveEndDate, 'MM/DD/YYYY').isBefore(moment(egr.effectiveStartDate, 'MM/DD/YYYY'))) {
    errors.push('Effective end date cannot be before the effective start date');
  }
  return errors;
};

export const DateField = ({ field }) => (
  <InputMask
    placeholder="mm/dd/yyyy"
    type="text"
    mask="12/39/4599"
    formatChars={DATE_FORMAT_CHARS}
    {...field}
  />
);
